import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { getSchemaUploadFileMoreCoi } from '../../../redux/actions/reviewSummary'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ReviewSummaryAttachFileCoiWidget from '../../../widgets/reviewSummary/ReviewSummaryAttachFileCoiWidget'

export default function ReviewSummaryAttachFileCoi() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // setSchema(mockSchema)
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaUploadFileMoreCoi(projectId)
      console.log(_schema)
      if (_schema.success) {
        setSchema(_schema.model)
      }
      // setSchema(_schema.model)
      // setSchema(mockSchema.model)
    } catch (e) {
      console.log('error', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ReviewSummaryAttachFileCoiWidget schema={schema.form} projectId={projectId} />
      <br />
    </SidebarProposal>
  )
}
